import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
export type AccountNameQueryVariables = GraphQLTypes.Exact<{
  id: GraphQLTypes.Scalars['String']['input'];
}>;

export type AccountNameQueryResult = { __typename?: 'Query' } & {
  account?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'tradingName'>>;
  legacyAccount?: GraphQLTypes.Maybe<{ __typename?: 'LegacyAccount' } & Pick<GraphQLTypes.LegacyAccount, 'name'>>;
};

export const AccountNameDocument = gql`
  query accountName($id: String!) {
    account(accountId: $id) {
      tradingName
    }
    legacyAccount(uuid: $id) {
      name
    }
  }
`;
